var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"visible":_vm.visible,"ok-text":"保存","width":"850px"},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.title))]),_c('a-transfer',{attrs:{"titles":['选择租户', '已选择租户'],"data-source":_vm.allocationData,"target-keys":_vm.targetKeys,"show-search":"","filter-option":_vm.filterOption,"rowKey":(record) => record.id,"list-style":{
      width: '350px',
      height: '950px',
    }},on:{"change":_vm.handleChange},scopedSlots:_vm._u([{key:"children",fn:function({
        props: {
          direction,
          filteredItems,
          selectedKeys,
          disabled: listDisabled,
        },
        on: { itemSelectAll, itemSelect },
      }){return [_c('a-table',{attrs:{"pagination":_vm.pagination,"row-selection":_vm.getRowSelection({
            disabled: listDisabled,
            selectedKeys,
            itemSelectAll,
            itemSelect,
          }),"columns":_vm.nameColumns,"data-source":filteredItems,"custom-row":({ key, disabled: itemDisabled }) => ({
            on: {
              click: () => {
                if (itemDisabled || listDisabled) return
                itemSelect(key, !selectedKeys.includes(key))
              },
            },
          })},on:{"change":_vm.tenantTableChange},scopedSlots:_vm._u([{key:"rentname",fn:function(text, record){return [_vm._v(" "+_vm._s(text || record.name)+" ("+_vm._s(record.id)+") ")]}}],null,true)})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }